import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment/moment';

@Pipe({
  name: 'gsbDatePipe'
})
export class GsbDatePipe implements PipeTransform {
  transform(date: Date): string {
    if (!date) {
      return '';
    } else {
      return moment(date).format('DD/MM/YYYY');
    }
  }
}
